import * as fetch from '../../utils/action'
import order from './modules/order'
import mall from './modules/mall'
import mallOrder from './modules/mall-order'
import datas from './datas'
import dataStatistic from './modules/data-statistic'
import agena from './modules/agena'
import customer from './modules/customer'
import information from './modules/information'
import boxManage from './modules/box-manage'
import sampleBoard from './modules/sample-board'
import labProduct from './modules/lab-product'
import bill from './modules/bill'
import productionTask from './modules/production-task'
import sample from './modules/sample'
import tableDownload from "./modules/table-download"
let actions = {
  // 更新用户信息
  updateUserInfo(ctx, data) {
    return fetch.updateUserInfo(data).then(response => {
      ctx.dispatch('refreshUserInfo')
      return response.data
    })
  },
  // 刷新用户信息
  refreshUserInfo(ctx) {
    /* global vm */
    vm.$auth.fetch({...vm.$auth.options.fetchData })
  },
  // 获取手机验证码（不可删除）
  getCode(ctx, data) {
    return fetch.getCode(data)
  },
  getMenu(ctx) {
    return fetch.getMenu().then(res => {
      let result = res.data
      result = datas.getMenu(result)
      ctx.commit('menuList', result)
      return res
    })
  },
  getDivision(ctx, data) {
    return fetch.getDivision(data).then(res => {
      return res.data
    })
  },
  getResuorceUrl(ctx, data) {
    return fetch.getResuorceUrl(data).then(res => {
      return res.data
    })
  },
  LocalIsEnabled(ctx, data) {
    return fetch.LocalIsEnabled(data).then(res => {
      return res.data
    })
  },
  changePassword(ctx, data) {
    return fetch.changePassword(data).then(res => {
      return res.data
    })
  },
  getCycleTime(ctx, data) {
    return fetch.getCycleTime(data).then(res => {
      return res.data
    })
  },
  getOperatorList(ctx, data) {
    return fetch.getOperatorList(data).then(res => {
      return res.data
    })
  },
  getOrderCountSummary(ctx, data) {
    return fetch.getOrderCountSummary(data).then(res => {
      return res.data
    })
  },
  getOrderCountExpiredOrder(ctx, data) {
    return fetch.getOrderCountExpiredOrder(data).then(res => {
      return res.data
    })
  },
  getOrderCountErrorOrder(ctx, data) {
    return fetch.getOrderCountErrorOrder(data).then(res => {
      return res.data
    })
  },
  getOrderStatusDetail(ctx, data) {
    return fetch.getOrderStatusDetail(data).then(res => {
      return res.data
    })
  },
  getOrderStatusError(ctx, data) {
    return fetch.getOrderStatusError(data).then(res => {
      return res.data
    })
  },
  getWatingOperateOrder(ctx, data) {
    return fetch.getWatingOperateOrder(data).then(res => {
      return res.data
    })
  },
  getChipType(ctx, data) {
    ctx.commit('updateChipType', data)
  },
  cancelBills(ctx, data) {
    return fetch.cancelBills(data).then(res => {
      return res.data
    })
  },
  ...order,
  ...mall,
  ...dataStatistic,
  ...agena,
  ...mallOrder,
  ...customer,
  ...information,
  ...boxManage,
  ...sampleBoard,
  ...labProduct,
  ...bill,
  ...productionTask,
  ...sample,
  ...tableDownload
}
export default actions